module.exports = __webpack_public_path__ + "media/img/frontend_application/thumb-09b81d018cc05cc5ec1a0eef7c1d1f2b.png";